export default (urlParameters) => {
  return {
    detail_panel: true,
    map_name_block: true,
    map_selector_button: true,
    pinned_map_bar: true,
    points_of_interest: true,
    storm_header_block: true,
    storm_map_selector_button: true,
    storm_spaghetti_map: true,
    ui_storage_name: 'lifestyleStormMapUIStore'
  }
}